import axios from '../axios';
import moment from 'moment';

export const DRONE_INSTANCE_STATUS = 'DRONE_INSTANCE_STATUS';
export const UPDATE_DATA = 'UPDATE_DATA';

const initialState = {
  droneList: [],
  recentLogTime: {},
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case DRONE_INSTANCE_STATUS:
      return {
        ...state,
        droneList: action.data.map((drone) => ({
          ...drone,
          isOnline: moment().diff(moment(drone.updatedAt), 'seconds') <= 300,
        })),
        recentLogTime: new Date(),
      };
    case UPDATE_DATA:
      return {
        ...state,
        droneList: state.droneList.filter((flight) => action.onlineFlight.includes(flight._id.toString())),
      };
    default:
      return state;
  }
}

export const droneInstanceStatus = (data) => {
  return {
    type: DRONE_INSTANCE_STATUS,
    data,
  };
};

export const updateOnlineFlight = (onlineFlight) => {
  return {
    type: UPDATE_DATA,
    onlineFlight,
  };
};

export const getDroneInstanceStatus = (data) => {
  return (dispatch, getState) => {
    axios
      .get(`/drone-instance-status`, { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } })
      .then((response) => {
        dispatch(droneInstanceStatus(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};
